/* Be careful, this is a contract with some native apps */
export const FIREBASE_ID_TOKEN = 'FIREBASE_ID_TOKEN'
export const PLATFORM = 'PLATFORM'
export const PRIMARY_STORAGE_KEY = 'PRIMARY_STORAGE_KEY'
export const FCM_TOKEN = 'FCM_TOKEN'
